import styled from "styled-components";

export const LayoutContainerText = styled.div`
  background-color: #d85959;
  font-family: Akrobat;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const LayoutContainerFilter = styled.div`
  width: 365px;
  height: 60px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  // background-color: #ff7e00;

  h1 {
    text-align: center;
    font-size: 20px;
    font-family: "Akrobat";
    color: #3d567a;
    margin-top: 20px;
  }
  `;
export const LayoutContainerFilterControl = styled.div`
margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    width: 90px;
    height: 32px;
    border: none;
    border-radius: 3px;
    font-size: 18px;
    font-family: "Akrobat";
    color: white;
    background-color: #d85959;
    cursor: pointer;
  }
`;
export const LayoutContainerFilterControlTables = styled.div`
  font-family: Akrobat;
  thead {
    th {
      padding: 10px 20px;
      color: #87a894;
      font-size: 14px;
      font-weight: 400;
    }
  }

  tbody {
    tr {
      &:nth-child(even) {
        background-color: #f6f6f6;
      }
      td {
        padding: 0 20px;
        text-align: center;
        font-size: 14px;
        height: 30px;
      }
    }
  }
`;
export const ModalLayoutContainer = styled.div`
  font-family: Akrobat;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.404);
  // background-color: transparent;
  position: fixed;
  top: -0px;
  z-index: 99999;
  display: flex;
  align-items: center;
`;
export const ModalLayoutContainerContent = styled.div`
  width: 800px;
  height: 615px;
  box-shadow: 2px 2px 15px 2px rgba(228, 228, 228, 0.493);
  background-color: #ffffff;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  align-self: center;
  border: none;
`;
export const ModalLayoutContainerContentHeader = styled.div`
  width: 100%;
  height: 30px;
  background-color: #ff7e00;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 16px;
    color: white;
    letter-spacing: 0.03rem;
    font-family: "Akrobat SemiBold";
  }
  span {
    position: absolute;
    top: 3px;
    left: 90%;
    float: right;
    font-size: 18px;
    font-family: "Akrobat";
    color: white;
    cursor: pointer;
  }
`;
export const ModalLayoutContainerContentDataGrid = styled.div`
  width: 95%;
  height: 520px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5px;
  overflow-x: auto;
  overflow-y: auto;
`;
export const ModalLayoutContainerContentDataGridProduct = styled.div`
  width: 90%;
  height: 150px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  border: 0.03px solid rgb(237, 237, 237);
  margin-bottom: 10px;
`;
export const ModalLayoutContainerContentDataGridProductRow = styled.div`
  width: 100%;
margin-bottom: 8px;
display: flex;
flex-direction: row;
justify-content: center;
border-bottom: 0.03px solid rgb(237, 237, 237);
padding-bottom: 5px;

.orange{
  background-color: #ff7e00;
}

.none-border{
  border: none;
}


h1{
  font-size: 16px;
  font-family: 'Akrobat';
  color: white;
}

p{
  width: 22%;
  font-size: 16px;
  font-family: 'Akrobat';
  color: #435C7F;

}

p:nth-child(2){
  width: 30%;
}
`;
export const ModalLayoutContainerContentDataGridProductRowOrange = styled(ModalLayoutContainerContentDataGridProductRow)`
  background-color: #ff7e00;
`;
export const ModalLayoutContainerContentDataGridProductRowNoneBorder = styled(ModalLayoutContainerContentDataGridProductRow)`
  border: none;
`;

export const ModalLayoutContainerContentDataGridProductField = styled.div`
  width: 80%;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

  label {
    font-size: 16px;
    font-family: "Akrobat";
    color: #435c7f;
    margin-right: 10px;
    margin-left: 5px;
  }

  a {
    margin-left: 8px;
    color: #9AA3B5;
  }

  input[type="radio"] {
    width: 25px;
    height: 25px;
    cursor: pointer;
  }

  input[type="radio"]:checked:before {
    content: "";
    display: block;
    position: relative;
    width: 25px;
    height: 25px;
    border-radius: 15px;
    background: url("/images/ok.png");
    background-color: white;
    background-size: 100% 100%;
    cursor: pointer;
  }

  input[type="text"] {
    width: 300px;
    height: 30px;
    border: 0.03px solid rgb(237, 237, 237);
    font-size: 14px;
    font-family: "Akrobat";
    color: rgb(13, 109, 253);
  }
`;
export const ModalLayoutContainerContentFilter = styled.div`
  width: 100%;
  height: 50px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  button {
    width: 197px;
    height: 40px;
    background-color: #ff7e00;
    font-size: 20px;
    font-family: "Akrobat";
    color: white;
    border: none;
    border-radius: 5px;
    margin-top: 10px;
    cursor: pointer;
  }
`;
